import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './Popover.scss';

const Popover = ({ show, onClose, triggerRef, children, width = 250, height = 300 }) => {
  const popoverRef = useRef(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [isPositioned, setIsPositioned] = useState(false);

  useEffect(() => {
    const calculatePosition = () => {
      if (triggerRef?.current) {
        const rect = triggerRef.current.getBoundingClientRect();
        const popoverWidth = width;
        const popoverHeight = height;

        let top = rect.bottom + 5;
        let { left } = rect;

        // Check if popover would go off right edge of screen
        if (left + popoverWidth > window.innerWidth) {
          left = window.innerWidth - popoverWidth - 10;
        }

        // Check if popover would go off bottom of screen
        if (top + popoverHeight > window.innerHeight) {
          top = rect.top - popoverHeight - 5;
        }

        // Ensure it doesn't go off left edge
        if (left < 10) {
          left = 10;
        }

        setPosition({ top, left });
        setIsPositioned(true);
      }
    };

    if (show) {
      calculatePosition();
      window.addEventListener('resize', calculatePosition);

      return () => {
        window.removeEventListener('resize', calculatePosition);
      };
    }

    setIsPositioned(false);
  }, [show, triggerRef, width, height]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)
        && triggerRef?.current && !triggerRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [show, onClose, triggerRef]);

  if (!show || !isPositioned) return null;

  return (
    <div
      ref={popoverRef}
      className="popover-component"
      style={{
        position: 'fixed',
        top: `${position.top}px`,
        left: `${position.left}px`,
        width: `${width}px`,
        zIndex: 1050
      }}
    >
      {children}
    </div>
  );
};

Popover.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  triggerRef: PropTypes.object,
  children: PropTypes.node.isRequired,
  width: PropTypes.number,
  height: PropTypes.number
};

export default Popover;
